
(function (Drupal) {
  Drupal.behaviors.headerSearch = {
    attach: function (context) {


      once('headerSearchOpen', '.ateed-header-search .ateed-begin-search ', context).forEach(function(el) {
        el.addEventListener('mousedown', function() {

          window.searchBlock = this.closest('.ateed-header-search')
          window.searchBlock.classList.add('search-open')
          window.ateedHeader = this.closest('.ateed-header')
          window.ateedHeader.classList.add('ateed-search-active')

        });
      });
      once('headerSearchClose', '.ateed-header-search .ateed-search-close', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          window.searchBlock = this.closest('.ateed-header-search')
          var keys = window.searchBlock.querySelector('#keys')
          keys.value = ''
          window.searchBlock.classList.remove('search-open')

          window.ateedHeader = this.closest('.ateed-header')
          window.ateedHeader.classList.remove('ateed-search-active')


        });
      });


      once('headerSearchClear', '.ateed-header-search .ateed-search-clear', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {

          window.searchBlock = this.closest('.ateed-header-search')
          var keys = window.searchBlock.querySelector('#keys')
          keys.value = ''
        });
      });

      once('headerSearchSubmit', '.ateed-header-search form', context).forEach(function(el) {
        el.addEventListener('submit', function(e) {

          window.searchBlock = this.closest('.ateed-header-search')
          var keys = window.searchBlock.querySelector('#keys')
          keys.classList.add('header-search-loading-anim')
        });
      });
    }
  }
})(Drupal);
